import template from './address.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    addressLabel: '<',
    address: '<',
    countries: '<',
    validationErrors: '<',
    key: '<',
    index: '<',
    showWarning: '<',
    isDisabled: '<',
    onFinished: '&'
  },
  controller: class controller {
    constructor($rootScope, $http, $mdMedia, dataService, helperService, Address) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.currentOrganization = null;
      ctrl.organizationCountry = null;
      ctrl.availableStates = [];
      ctrl.availableStreetTypes = [];
      ctrl.searchTerm = '';
      ctrl.searchStreetTypeTerm = '';
      ctrl.isReady = false;

      ctrl.initialize = () => {
        ctrl.currentOrganization = $rootScope.CurrentOrganization;
        ctrl.organizationCountry = helperService.getOrganizationCountry();
        ctrl.availableStates = helperService.getAvailableAddressStates();
        ctrl.availableStreetTypes = helperService.getAvailableAddressStreetTypes();
        ctrl.addressLabel = ctrl.addressLabel || 'Search address';
        ctrl.address = ctrl.address || Address.blank();
        ctrl.countries = ctrl.countries || [];
        ctrl.validationErrors = ctrl.validationErrors || [];
        ctrl.key = ctrl.key || 'address';
        ctrl.prefix = ctrl.key === 'employerAddress' ? 'person.employments.' : '';
        ctrl.pathSegment =
          ctrl.index !== undefined ? `${ctrl.prefix}${ctrl.index}.${ctrl.key}` : `${ctrl.key}`;
        ctrl.showWarning = ctrl.showWarning || false;
        ctrl.isDisabled = ctrl.isDisabled || false;
        ctrl.isReady = true;
      };

      ctrl.changeCountry = () => {
        const country = _.find(
          ctrl.countries,
          (c) => c?.name?.common?.toLowerCase() === ctrl.address?.country?.toLowerCase()
        );
        if (country?.name?.common) {
          ctrl.address.city = '';
          ctrl.address.country = country?.name?.common || '';
          ctrl.address.countryCode = country?.cca2 || '';
          ctrl.address.district = '';
          ctrl.address.formatted = '';
          ctrl.address.id = '';
          ctrl.address.idLinkedAddress = '';
          ctrl.address.latitude = '';
          ctrl.address.longitude = '';
          ctrl.address.placeId = '';
          ctrl.address.postCode = '';
          ctrl.address.state = '';
          ctrl.address.street = '';
          ctrl.address.streetNumber = '';
          ctrl.address.streetType = '';
          ctrl.address.suburb = '';
          ctrl.address.suiteNumber = '';
          ctrl.address.postOfficeBox = '';
          ctrl.address.isPostOfficeBoxEnabled = false;
          ctrl.saveAddress();
        }
      };

      ctrl.getCountryCca2 = () => {
        const country = _.find(
          ctrl.countries,
          (c) => c?.name?.common?.toLowerCase() === ctrl.address?.country?.toLowerCase()
        );
        return country?.cca2 || ctrl.organizationCountry?.cca2 || 'AU';
      };

      ctrl.isValidPostCode = (postCode, country) => {
        if (country === 'Australia' || country === 'New Zealand') {
          return /\b(\d{4})\b/.test(postCode) && String(postCode).length === 4;
        }
        return true;
      };

      ctrl.searchAddresses = (query) =>
        dataService
          .apiRequest(
            null,
            null,
            null,
            null,
            $http.get,
            '/api/v1/integration/sensis/address/find',
            { params: { address: query, country: ctrl.getCountryCca2() } }
          )
          .then((res) => res.results || []);

      ctrl.selectedAddressChange = (address) => {
        if (address && address.search_result_id) {
          return dataService
            .apiRequest(
              null,
              null,
              null,
              null,
              $http.get,
              '/api/v1/integration/sensis/address/get',
              { params: { id: address.search_result_id, country: ctrl.getCountryCca2() } }
            )
            .then((res) => {
              if (res && res.result) {
                if (ctrl.address?.isPostOfficeBoxEnabled) {
                  ctrl.address.postOfficeBox =
                    _.isString(res.result.street_address) &&
                    !_.isEmpty(res.result.street_address)
                      ? res.result.street_address
                      : ctrl.address?.postOfficeBox || '';
                } else {
                  ctrl.address.suiteNumber =
                    _.isString(res.result.subpremise) && !_.isEmpty(res.result.subpremise)
                      ? res.result.subpremise
                      : ctrl.address?.suiteNumber || '';
                  ctrl.address.streetNumber =
                    _.isString(res.result.street_number) && !_.isEmpty(res.result.street_number)
                      ? res.result.street_number
                      : ctrl.address?.streetNumber || '';
                  ctrl.address.street =
                    _.isString(res.result.street_name) && !_.isEmpty(res.result.street_name)
                      ? res.result.street_name
                      : ctrl.address?.street || '';
                  ctrl.address.streetType =
                    _.isString(res.result.street_type) && !_.isEmpty(res.result.street_type)
                      ? res.result.street_type
                      : ctrl.address?.streetType || '';
                }
                ctrl.address.suburb =
                  _.isString(res.result.suburb) && !_.isEmpty(res.result.suburb)
                    ? res.result.suburb
                    : ctrl.address?.city || '';
                ctrl.address.city =
                  _.isString(res.result.city) && !_.isEmpty(res.result.city)
                    ? res.result.city
                    : ctrl.address?.city || '';
                ctrl.address.state =
                  _.isString(res.result.state) && !_.isEmpty(res.result.state)
                    ? res.result.state
                    : ctrl.address?.state || '';
                ctrl.address.country =
                  _.isString(res.result.country) && !_.isEmpty(res.result.country)
                    ? res.result.country.toLowerCase().capitalizeFirstLetter()
                    : ctrl.address?.country || '';
                ctrl.address.countryCode = ctrl.getCountryCca2();
                ctrl.address.latitude =
                  _.isNumber(res.result.geo_lat) && !_.isEmpty(res.result.geo_lat)
                    ? res.result.geo_lat
                    : ctrl.address?.latitude || '';
                ctrl.address.longitude =
                  _.isNumber(res.result.geo_lon) && !_.isEmpty(res.result.geo_lon)
                    ? res.result.geo_lon
                    : ctrl.address?.longitude || '';
                ctrl.address.postCode =
                  _.isString(res.result.postcode) && !_.isEmpty(res.result.postcode)
                    ? res.result.postcode
                    : ctrl.address?.postCode || '';
                ctrl.address.formatted =
                  _.isString(res.result.formatted_address) &&
                  !_.isEmpty(res.result.formatted_address)
                    ? res.result.formatted_address
                    : ctrl.address?.formatted || '';
                ctrl.saveAddress();
              }
            });
        }
        return null;
      };

      ctrl.onBlur = () => {
        ctrl.address.streetType = ctrl.searchStreetTypeTerm;
        ctrl.saveAddress();
      };

      ctrl.searchStreetTypes = () =>
        _.filter(
          ctrl.availableStreetTypes,
          (type) =>
            type?.value?.toLowerCase()?.indexOf(ctrl.searchStreetTypeTerm?.toLowerCase()) !== -1
        );

      ctrl.hasValidationError = ({ path }) =>
        helperService.hasValidationError({ errors: ctrl.validationErrors, path });

      ctrl.saveAddress = _.debounce(() => {
        ctrl.onFinished();
      }, 1500);

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
